<template>
  <div>
    <div class="entertainment-card" v-for="(item,index) in listData" :key="index">
      <div class="flex-between-box">
        <div class="bd-left">
          <van-image
          width="1.9rem"
          height="1.9rem"
          class="list-image"
          fit="cover"
          :src="item.ShoppingCartItemModel.Picture.FullSizeImageUrl"
          @click="goDetail(item.ShoppingCartItemModel.ProductId)"
          />
          <!-- <img class="union-pay-ico" src="../../assets/union_pay_ico.png" alt=""> -->
          <!-- <div class="label" v-show="item.ShoppingCartItemModel.Picture.ImageUrl">
            <img class="label-img" :src="item.ShoppingCartItemModel.Picture.ImageUrl" />
          </div> -->
        </div>
        <div class="bd-right">
          <div class="list-title">{{item.ShoppingCartItemModel.ProductName}}</div>
          <div class="list-price">
            <!-- <div class="price-left"> <span class="price-color">{{priceFormat(item.ShoppingCartItemModel.UnitPrice)}}</span><span class="number">x{{item.ShoppingCartItemModel.Quantity}}</span></div> -->
            <div class="price-right"> <span class="price-color">{{priceFormat(item.ShoppingCartItemModel.SubTotal)}}</span> 美元</div>
            <div>X{{item.ShoppingCartItemModel.Quantity}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Dialog } from 'vant'
// import uniq from 'lodash/uniq'

export default {
  name: 'EntertainmentCard',

  components: {
  },

  data () {
    return {
      goodsNumberMin: 1,
      editShow: false,
      currentProduct: {},
      listData: []
    }
  },

  props: {
    isShow: {
      type: Boolean,
      default: true
    },
    cardData: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  watch: {
    cardData: {
      handler (val) {
        this.listData = val
      },
      deep: true
    }
  },
  created () {
    this.listData = this.cardData
  },
  // computed: {
  //   cardDataFormat () {
  //     return this.cardData.map(x => {
  //       const productIds = uniq(x.packageItems.map(j => j.productId))
  //       return {
  //         ...x,
  //         packageItems: productIds.map(j => (x.packageItems.find(y => y.productId === j)))
  //       }
  //     })
  //   }
  // },
  methods: {
    priceFormat (current) {
      return current && current !== '' ? current.substr(0, current.length - 2) : current
    },
    // 删除产品
    deleteBtn (val) {
      Dialog.confirm({
        message: '确定要删除该产品？'
      }).then(() => {
        // on confirm
        this.deleteProduct(val)
      }).catch(() => {
        // on cancel
      })
    },
    goDetail (val) {
      this.$router.push(`/product/detail/${val}`)
    }
  }
}
</script>

<style lang="less" scoped>
.entertainment-card{
  font-size: 20px;
  padding: 20px 20px 0;
  .flex-between-box {
    margin-bottom: 30px;
  }
  .item-top-tag{
    font-size: 26px;
    color: @main-gray3;
    padding: 5px 20px;
    background-color: #f0f0f0;
    margin-bottom: 20px;
    display: inline-block;
    border-radius: 46px;
    padding-bottom: 0px;
  }
  .list-image{
    display: block;
    // margin-bottom: 15px;
  }
  .bd-left{
    width: 190px;
    .union-pay-ico{
      width: 140px;
      height: 30px;
      display: block;
      padding: 0;
      margin: 0;
    }
  }
  .bd-right{
    position: relative;
    flex: 1;
    padding-left: 30px;
    .first-line {
      display: flex;
      justify-content: space-between;
      align-items: baseline;
    }
    .list-title{
      font-size: 26px;
      color: @main-color;
      margin-bottom: 5px;
      margin-top: -5px;
      height: 130px;
    }
    .list-price{
      display: flex;
      justify-content: space-between;
      align-items: baseline;
      margin-bottom: 10px;
      margin-right: 15px;
      .number{
        display: inline-block;
        margin-left: 10px;
      }
      .price-left{
        font-size: 20px;
      }
      .price-right{
        .price-color{
          font-size: 30px;
          font-weight: 600;
        }
      }
    }
    .entertainment-item{
      margin-bottom: 28px;
      font-size: 20px;
      .blue-color{
        padding-right: 10px;
        flex: 1;
      }
    }
    .list-time{
      margin-bottom: 20px;
    }
    .list-tips{
      margin-bottom: 20px;
    }
    .order-detail{
      .detail-list{
        margin-bottom: 25px;
      }
    }
  }
  .label {
    // width: 180px;
    margin-top: 10px;
    img{
      // width: 100%;
      height: 30px;
    }
  }
  .card-cell {
    padding-bottom: 0px;
  }
}
</style>
